export default __webpack_public_path__ + "media/Fabric.433552c1.svg";